import type { QueryIntent } from '../../constants';
import { NLPSearchJSONResultFormat } from '../types';

import { getTypedJSONResultData } from './getTypedJSONResultData';

export const getKnowledgeCardResultCount = ({
	answerString,
	smartAnswersRoute,
}: {
	answerString: string;
	smartAnswersRoute: QueryIntent;
}): number => {
	if (!answerString) {
		return 0;
	}

	const { parsedResult, parsedType } = getTypedJSONResultData({ answerString, smartAnswersRoute });

	switch (parsedType) {
		case NLPSearchJSONResultFormat.TEAM:
			return 'id' in parsedResult && parsedResult.id ? 1 : 0;
		case NLPSearchJSONResultFormat.WHO:
		case NLPSearchJSONResultFormat.PERSON:
		case NLPSearchJSONResultFormat.AGENT:
		case NLPSearchJSONResultFormat.WORK:
			return Array.isArray(parsedResult) ? parsedResult.length : 0;
		default:
			return 0;
	}
};
